import { Z as c, _ as f } from "../../vendor-Dd6qj6gJ.js";
import { useCallback as u } from "react";
const p = typeof CSS < "u" && typeof CSS.supports == "function" && CSS.supports("field-sizing", "content");
function n(o, i = 0) {
  const e = Number.parseFloat(o);
  return Number.isNaN(e) ? i : e;
}
function g(o, i) {
  const e = window.getComputedStyle(o), r = n(e.lineHeight) || n(e.fontSize, 16) * 1.5, s = n(e.paddingBlockStart) + n(e.paddingBlockEnd) + n(e.borderBlockStartWidth) + n(e.borderBlockEndWidth);
  return r * i + s;
}
function d(o, { isEnabled: i, value: e, maxRows: r }) {
  const s = u(() => {
    const t = o.current;
    if (!i || !t || (r !== void 0 && (t.style.maxHeight = `${g(t, r)}px`), p))
      return;
    const l = t.style.overflow;
    t.style.overflow = "hidden", t.style.height = "auto", t.style.height = `${t.scrollHeight + t.offsetHeight - t.clientHeight}px`, t.style.overflow = l;
  }, [o, i, r]);
  c(() => {
    s();
  }, [s, e]), c(() => {
    const t = o.current;
    i || !t || (t.style.height = "", t.style.maxHeight = "");
  }, [o, i]), f({ ref: i ? o : void 0, onResize: s });
}
export {
  p as supportsFieldSizing,
  d as useAutoResize
};
